// @flow
import { colors } from 'bench-style-constants';
import React from 'react';
import { SidebarSection, Text, TextBlock } from 'bench-internal-theme';
import styled from 'styled-components';

import { type JournalEntryHistoryEntry } from './types';
import getFormattedDateString from './getFormattedDateString';
import { generateHistoryMessageText } from './generateHistoryMessageText';

const EntryWrapper = styled.div`
  margin-bottom: 0px;
`;

type JournalEntryHistoryProps = {
  historyEntries: Array<JournalEntryHistoryEntry>,
};

const JournalEntryHistory = ({ historyEntries }: JournalEntryHistoryProps) => (
  <SidebarSection
    background={colors.shell}
    title="Transaction History"
    padding="24px 0px 24px 0px"
    titlePadding="0px 24px 0px 24px"
  >
    {historyEntries.map(entry => {
      const shouldHighlight =
        entry.user.fullName &&
        entry.message &&
        entry.user.fullName.toLowerCase().includes('client') &&
        entry.message.includes('changed the ledger');
      return (
        <EntryWrapper
          key={`${entry.date}-${entry.user.fullName}`}
          style={{
            backgroundColor: shouldHighlight ? colors.brightyellow : undefined,
            padding: '2px 24px 8px 24px', // top right bottom left
          }}
        >
          <div>
            <Text styleType="mediumBold">{`${entry.user.fullName || 'Unknown'}  `}</Text>
            <Text styleType="small">{getFormattedDateString(entry.date)}</Text>
          </div>
          <TextBlock>{generateHistoryMessageText(entry)}</TextBlock>
        </EntryWrapper>
      );
    })}
  </SidebarSection>
);

export default JournalEntryHistory;
